import { DeeplinkState } from '../../../../@types';

const initialState: DeeplinkState = {
  deeplinkUrl: '',
};
export default initialState;
